import React from "react";
import { ScheduleComparison, milesFromMeters, hoursFromSeconds, deltaTone } from "../../../models/ScheduleComparison";
import "./Scorecard.scss";

const signed = (n: number, digits = 0) => `${n > 0 ? "+" : ""}${n.toFixed(digits)}`;

export default function DeltaHeader({ comparison }: { comparison: ScheduleComparison }) {
  const { actual, deltas } = comparison;
  const tiles = [
    { label: "Drivers", value: `${actual.driversUsed}`, delta: signed(deltas.driversUsed), tone: deltaTone(deltas.driversUsed) },
    { label: "Drive time", value: `${hoursFromSeconds(actual.drivingSeconds).toFixed(1)}h`,
      delta: `${signed(hoursFromSeconds(deltas.drivingSeconds), 1)}h`, tone: deltaTone(deltas.drivingSeconds) },
    { label: "Miles", value: milesFromMeters(actual.meters).toFixed(1),
      delta: signed(milesFromMeters(deltas.meters), 1), tone: deltaTone(deltas.meters) },
    { label: "Operating cost", value: `$${(Number(actual.cost.operating) || 0).toFixed(2)}`,
      delta: `${deltas.costTotal > 0 ? "+" : ""}$${deltas.costTotal.toFixed(2)}`, tone: deltaTone(deltas.costTotal) },
  ];
  return (
    <div className="scorecard-delta-header">
      {tiles.map((t) => (
        <div className="tile" key={t.label}>
          <div className="tile-label">{t.label}</div>
          <div className="tile-value">{t.value}</div>
          <div className={`tile-delta ${t.tone}`}>{t.delta}</div>
        </div>
      ))}
    </div>
  );
}
